import { ArrowLeftIcon, ArrowTrendingUpIcon, PencilIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import { clearSelectedForecast, createForecastRequest, ForecastLoadingKeys, getForecastRequest, upsertForecastDataRequest } from "../../slices/quickbooks/forecastSlice";
import { useDispatch, useSelector } from "react-redux";
import { LoaderSpinner } from "../../components/LoaderSpinner";
import { ROUTES } from "../../consts/general";
import { useNavigate } from "react-router-dom";
import { arrayHasItems } from "../../helpers/common";
import { SelectDropdown } from "../../components/SelectDropdown";
import { ForecastPeriodSection } from "../../components/quickbooks/ForecastPeriodSection";
import { ForecastTotals } from "../../components/quickbooks/ForecastTotals";
import { AllocateAdSpendSwitcher } from "../../components/quickbooks/AllocateAdSpendSwitcher";
import { ForecastMethodSection } from "../../components/quickbooks/ForecastMethodSection";
import { forecastOptions, monthKeysFullnameEnum, monthsOptions, viewForecastOptions } from "../../consts/quickbooksReports";
import { ForecastInput } from "../../components/quickbooks/ForecastInput";
import { MonthlyAllocationSection } from "../../components/quickbooks/MonthlyAllocationSection";
import { ForecastProductSelect } from "../../components/quickbooks/ForecastProductSelect";
import { createNewGroup, getGroupsBySelect, ProductGroupLoadingKeys } from "../../slices/productGroupSlice";
import { MonthlySummaryForecast } from "../../components/quickbooks/MonthlySummaryForecast";
import { ChannelSplit } from "../../components/quickbooks/ChannelSplit";
import { defaultAdSpendAllocations, defaultAllocation, defaultMonthlySummary } from "../../consts/forecast";
import { annualRevenueCalculation, annualUnitsCalculation, fillAllMonths, getEditedData, marginAdSpendCalculation, quantityAdSpendCalculation, recalculateMonthlySummaryByYear, revenueAdSpendCalculation } from "../../helpers/quickbooks";
import { AdSpendAllocationForecast } from "../../components/quickbooks/AdSpendAllocationForecast";
import { toast } from "react-toastify";
import { RevenueForecastPreview } from "../../components/quickbooks/RevenueForecastPreview";
import { transformOptions } from "../../helpers/forecast";
import { ForecastEditModal } from "../../components/quickbooks/ForecastEditModal";

const Forecast = ({
    marginFromSidebar,
    access
}) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const pageParams = window?.location?.search ? new URLSearchParams(window?.location?.search) : null;
    const forecastId = pageParams?.get("id") ? Number(pageParams?.get("id")) : null;

    const [forecastEditModalIsOpen, setForecastEditModalIsOpen] = useState(false);
    const [forecastData, setForecastData] = useState(null);
    const [forecastDataAccept, setForecastDataAccept] = useState(false);
    const [editedForecastData, setEditedForecastData] = useState(null);
    const [selectedForecastType, setSelectedForecastType] = useState("month");
    const [selectedForecastMethod, setSelectedForecastMethod] = useState("ad-spend");
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [editedSelectedProduct, setEditedSelectedProduct] = useState(null);
    const [editedMonth, setEditedMonth] = useState("");
    const [selectedMonth, setSelectedMonth] = useState("jan");
    const [allocateAdSpendView, setAllocateAdSpendView] = useState(false);
    const [editingYearMode, setEditingYearMode] = useState(false);
    const [jumpFromMethod, setJumpFromMethod] = useState(null);
    const [totals, setTotals] = useState(null);
    const [totalsByProducts, setTotalsByProducts] = useState(null);
    const [showPreview, setShowPreview] = useState(false);
    const [savedTypes, setSavedTypes] = useState({});
    const [previewData, setPreviewData] = useState({});

    // Filters
    const [selectedView, setSelectedView] = useState("all_products");
    const [selectedChannel, setSelectedChannel] = useState("all_channels");

    // Month
    // ad-spend
    const [adSpendMer, setAdSpendMer] = useState(0);
    const [productAdSpend, setProductAdSpend] = useState(0);
    const [aovAdSpend, setAovAdSpend] = useState(0);
    const [revenueAdSpend, setRevenueAdSpend] = useState(0);
    const [quantityAdSpend, setQuantityAdSpend] = useState(0);
    const [beroasAdSpend, setBeroasAdSpend] = useState(0);
    const [marginAdSpend, setMarginAdSpend] = useState(0);
    // revenue
    const [productRevenueTarget, setProductRevenueTarget] = useState(0);
    const [aovRevenue, setAovRevenue] = useState(0);
    // channel
    const [percentagesChannelsByMonths, setPercentagesChannelsByMonts] = useState(0);
    const [monthShopifyChannel, setMonthShopifyChannel] = useState(60);
    const [monthAmazonChannel, setMonthAmazonChannel] = useState(30);
    const [monthWholesaleChannel, setMonthWholesaleChannel] = useState(10);
    const [monthlySummaryByMonth, setMonthlySummaryByMonth] = useState(null);
    const [adSpendAllocationsByMonth, setAdSpendAllocationsByMonth] = useState(null);
    const [monthMethods, setMonthMethods] = useState(null);

    // Year
    const [annualAdSpendYear, setAnnualAdSpendYear] = useState(0);
    const [merYear, setMerYear] = useState(0);
    const [aovYear, setAovYear] = useState(0);
    const [beroasYear, setBeroasYear] = useState(0);
    const [annualRevenueYear, setAnnualRevenueYear] = useState(0);
    const [annualUnitsYear, setAnnualUnitsYear] = useState(0);
    const [monthlyAllocationData, setMonthlyAllocationData] = useState(defaultAllocation);
    // revenue
    const [productRevenueTargetYear, setProductRevenueTargetYear] = useState(0);
    const [aovRevenueYear, setAovRevenueYear] = useState(0);
    // channel
    const [percentagesChannelsByYear, setPercentagesChannelsByYear] = useState(0);
    const [yearShopifyChannel, setYearShopifyChannel] = useState(60);
    const [yearAmazonChannel, setYearAmazonChannel] = useState(30);
    const [yearWholesaleChannel, setYearWholesaleChannel] = useState(10);
    const [monthlySummaryByYear, setMonthlySummaryByYear] = useState(null);
    const [adSpendAllocationsByYear, setAdSpendAllocationsByYear] = useState(null);

    const {
        loading: forecastLoading,
        loadingKeys: forecastLoadingKeys,
        firstLoadComplete: forecastFirstLoadComplete,
        selectedForecast,
    } = useSelector((state) => state.forecast);

    const {
      groupsBySelect,
      loading: productGroupLoading,
      loadingKeys: productGroupKeys
    } = useSelector((state) => state.productGroup);

    useEffect(() => {
        if (!forecastId) return;
        dispatch(getGroupsBySelect({}));
    }, [forecastId]);

    const cleanUpValues = () => {
        setForecastData(null);
        setForecastDataAccept(false);
        setShowPreview(false);
        setSavedTypes({});
        setTotalsByProducts(null);
        setEditedForecastData(null);
        setSelectedForecastType("month");
        setSelectedForecastMethod("ad-spend");
        setEditedSelectedProduct(null);
        setEditedMonth("");
        setSelectedMonth("jan");
        setAllocateAdSpendView(false);
        setEditingYearMode(false);
        setJumpFromMethod(null);
        setSelectedView("all_products");
        setSelectedChannel("all_channels");
        setAdSpendMer(0);
        setProductAdSpend(0);
        setAovAdSpend(0);
        setRevenueAdSpend(0);
        setQuantityAdSpend(0);
        setBeroasAdSpend(0);
        setMarginAdSpend(0);
        setProductRevenueTarget(0);
        setAovRevenue(0);
        setProductRevenueTargetYear(0);
        setAovRevenueYear(0);
        setPercentagesChannelsByMonts(0);
        setMonthShopifyChannel(60);
        setMonthAmazonChannel(30);
        setMonthWholesaleChannel(10);
        setMonthlySummaryByMonth(defaultMonthlySummary);
        setAdSpendAllocationsByMonth(0);
        setAnnualAdSpendYear(0);
        setTotals(null);
        setMerYear(0);
        setAovYear(0);
        setBeroasYear(0);
        setAnnualRevenueYear(0);
        setAnnualUnitsYear(0);
        setMonthlyAllocationData(defaultAllocation);
        setPercentagesChannelsByYear(100);
        setYearShopifyChannel(60);
        setYearAmazonChannel(30);
        setYearWholesaleChannel(10);
        setMonthlySummaryByYear(null);
        setAdSpendAllocationsByYear(null);
    }

    const getForecastIsLoading = () => 
        forecastLoading && forecastLoadingKeys.includes(ForecastLoadingKeys.getForecast);
    const updateForecastsIsLoading = () => 
        forecastLoading && forecastLoadingKeys.includes(ForecastLoadingKeys.updateForecast);
    const productsByGroupIsLoading = () => 
        productGroupLoading && productGroupKeys.includes(ProductGroupLoadingKeys.getGroupValues);
    const createProductGroupIsLoading = () => 
        productGroupLoading && productGroupKeys.includes(ProductGroupLoadingKeys.createGroup);

    useEffect(() => {
        return () => {
           cleanUpValues();
           dispatch(clearSelectedForecast({}));
        }
    }, []);

    useEffect(() => {
        if (forecastId) {
            dispatch(getForecastRequest({ id: forecastId }));
        }
    }, [forecastId]);

    useEffect(() => {
        if (!selectedForecast) return;
        if (arrayHasItems(groupsBySelect) && !selectedProduct) {
            setSelectedProduct(groupsBySelect[0].value)
        }
    }, [groupsBySelect, selectedForecast]);

    useEffect(() => {
        if (selectedForecast) {
            setForecastData(selectedForecast?.data);
            setTotals(selectedForecast?.totals);
            setForecastDataAccept(true);
        }
    }, [selectedForecast?.id, getForecastIsLoading()]);

    const handleOnSaveProduct = async () => {
        const monthResult = [];
        const yearResult = [];

        const getRoundedSum = (obj) => {
            const sum = Object.values(obj || {}).reduce((acc, val) => acc + (parseFloat(val) || 0), 0);
            return Number(sum.toFixed(2));
        };

        const getRoundedArraySum = (arr) => {
            const sum = (arr || []).reduce((acc, item) => acc + (parseFloat(item?.percentage) || 0), 0);
            return Number(sum.toFixed(2));
        };

        for (const productId in editedForecastData.month) {
            const productData = editedForecastData.month[productId]?.months;
            const productName = (groupsBySelect || []).find((product) => product.value === Number(productId))?.label || "";

            for (const monthKey in productData) {
                const monthData = productData[monthKey];

                // Check channel split
                const splitTotal = getRoundedSum(monthData.channel_split);
                if (splitTotal !== 100) {
                    monthResult.push({
                        productName,
                        month: monthKeysFullnameEnum[monthKey],
                        percentages: splitTotal,
                    });
                }

                // Check ad spend allocations
                if (monthData.allocate_ad_spend) {
                    const allocTotal = getRoundedArraySum(monthData.ad_spend_allocations);
                    if (allocTotal !== 100) {
                        monthResult.push({
                            productName,
                            month: `${monthKeysFullnameEnum[monthKey]} - Ad Spend Allocation`,
                            percentages: allocTotal,
                        });
                    }
                }
            }
        }

        for (const productId in editedForecastData.year) {
            const yearData = editedForecastData.year[productId];
            const productName = (groupsBySelect || []).find((product) => product.value === Number(productId))?.label || "";

            // Check monthly allocation
            const allocationTotal = getRoundedSum(yearData.monthly_allocation);
            if (allocationTotal !== 100) {
                yearResult.push({
                    productName,
                    month: 'Monthly Allocation',
                    percentages: allocationTotal,
                });
            }

            // Check channel split
            const splitTotal = getRoundedSum(yearData.channel_split);
            if (splitTotal !== 100) {
                yearResult.push({
                    productName,
                    month: 'Channel Split',
                    percentages: splitTotal,
                });
            }

            // Check ad spend allocations
            if (yearData.allocate_ad_spend) {
                const allocTotal = getRoundedArraySum(yearData.ad_spend_allocations);
                if (allocTotal !== 100) {
                    yearResult.push({
                        productName,
                        month: 'Ad Spend Allocation',
                        percentages: allocTotal,
                    });
                }
            }
        }

        if (arrayHasItems(monthResult) || arrayHasItems(yearResult)) {
            const monthMessages = monthResult.map(
                ({ productName, month, percentages }, idx) => (
                    <div key={`month-${idx}`}>
                        ❌ {productName} - {month} - {percentages}%
                    </div>
                )
            );
            const yearMessages = yearResult.map(
                ({ productName, month, percentages }, idx) => (
                    <div key={`year-${idx}`}>
                        ❌ {productName} - {month} - {percentages}%
                    </div>
                )
            );
            toast.error(
                <div>
                    {arrayHasItems(monthMessages) && (
                        <>
                            <strong>Month Issues:</strong>
                            {monthMessages}
                        </>
                    )}
                    {arrayHasItems(yearMessages) && (
                        <>
                            <br />
                            <strong>Year Issues:</strong>
                            {yearMessages}
                        </>
                    )}
                </div>,
                {
                    position: 'bottom-right',
                    duration: 8000,
                }
            );
            return;
        }

        const editedMonth = editedForecastData?.month;
        const editedYear = editedForecastData?.year;
        let newEditedForecastData = {};

        if (editedMonth) {
            newEditedForecastData.month= Object.fromEntries(
                Object.entries(editedMonth).map(([id, value]) => [
                    id,
                    {
                        ...value,
                        forecast_last_period: savedTypes[id] || null
                    }
                ])
            );
        }
        if (editedYear) {
            newEditedForecastData.year = Object.fromEntries(
                Object.entries(editedYear).map(([id, value]) => [
                    id,
                    {
                        ...value,
                        forecast_last_period: savedTypes[id] || null
                    }
                ])
            );
        }

        await dispatch(upsertForecastDataRequest({
            id: selectedForecast?.id,
            editedData: newEditedForecastData
        })).unwrap();
        // cleanUpValues();
        await dispatch(getForecastRequest({ id: forecastId })).unwrap();
    };

    const handleChannelSplitAccept = () => {

        const newData = getEditedData({
            forecastData,
            editedForecastData,
            selectedProduct
        });

        const currentAdSpendMer = Number(adSpendMer);
        const currentProductAdSpend = Number(productAdSpend);
        const currentAovAdSpend = Number(aovAdSpend);
        const currentBeroasAdSpend = Number(beroasAdSpend);
        const currentProductRevenueTarget = Number(productRevenueTarget);
        const currentAovRevenue = Number(aovRevenue);

        const currentShopifyChannel = Number(monthShopifyChannel);
        const currentAmazonChannel = Number(monthAmazonChannel);
        const currentWholesaleChannel = Number(monthWholesaleChannel);

        const revenueAdSpendCalc = revenueAdSpendCalculation({
            adSpendMer: currentAdSpendMer,
            productAdSpend: currentProductAdSpend
        });
        const quantityAdSpendCalc = quantityAdSpendCalculation({
            adSpendMer: currentAdSpendMer,
            productAdSpend: currentProductAdSpend,
            aovAdSpend: currentAovAdSpend
        });
        const marginAdSpendCalc = marginAdSpendCalculation({
            adSpendMer: currentAdSpendMer,
            productAdSpend: currentProductAdSpend,
            beroasAdSpend: currentBeroasAdSpend
        });

        const monthRevenueAdSpend = Number(currentAdSpendMer) * Number(currentProductAdSpend);
        const monthRevenueManualTarget = Number(currentProductRevenueTarget);

        const monthUnitsAdSpend = Number(currentAovAdSpend) ? ((Number(currentAdSpendMer) * Number(currentProductAdSpend)) / Number(currentAovAdSpend)) : 0;
        const monthUnitsManualTarget = Number(currentAovRevenue) ? (Number(currentProductRevenueTarget) / Number(currentAovRevenue)) : 0;

        const monthShopifyAdSpend = Math.round(monthRevenueAdSpend * ((Number(monthShopifyChannel) || 0) / 100));
        const monthAmazonAdSpend = Math.round(monthRevenueAdSpend * ((Number(monthAmazonChannel) || 0) / 100));
        const monthWholesaleAdSpend = Math.round(monthRevenueAdSpend * ((Number(monthWholesaleChannel) || 0) / 100));

        const monthShopifyManualTarget = Math.round(monthRevenueManualTarget * ((Number(monthShopifyChannel) || 0) / 100));
        const monthAmazonManualTarget = Math.round(monthRevenueManualTarget * ((Number(monthAmazonChannel) || 0) / 100));
        const monthWholesaleManualTarget = Math.round(monthRevenueManualTarget * ((Number(monthWholesaleChannel) || 0) / 100));

        const monthly_summary = {
            "ad_spend": {
                aov: {},
                ad_spend: {},
                mer: {},
                total_revenue: {},
                total_units: {},
                shopify: {},
                amazon: {},
                wholesale: {}
            },
            "revenue_target": {
                aov: {},
                ad_spend: {},
                mer: {},
                total_revenue: {},
                total_units: {},
                shopify: {},
                amazon: {},
                wholesale: {} 
            }
        };
                        
        monthly_summary["ad_spend"].aov = fillAllMonths(currentAovAdSpend);
        monthly_summary["ad_spend"].ad_spend = fillAllMonths(currentProductAdSpend);
        monthly_summary["ad_spend"].mer = fillAllMonths(currentAdSpendMer);
        monthly_summary["ad_spend"].total_revenue = fillAllMonths(monthRevenueAdSpend);
        monthly_summary["ad_spend"].total_units = fillAllMonths(monthUnitsAdSpend);
        monthly_summary["ad_spend"].shopify = fillAllMonths(monthShopifyAdSpend);
        monthly_summary["ad_spend"].amazon = fillAllMonths(monthAmazonAdSpend);
        monthly_summary["ad_spend"].wholesale = fillAllMonths(monthWholesaleAdSpend);

        monthly_summary["revenue_target"].aov = fillAllMonths(currentAovAdSpend);
        monthly_summary["revenue_target"].ad_spend = fillAllMonths(currentProductAdSpend);
        monthly_summary["revenue_target"].mer = fillAllMonths(currentAdSpendMer);
        monthly_summary["revenue_target"].total_revenue = fillAllMonths(monthRevenueManualTarget);
        monthly_summary["revenue_target"].total_units = fillAllMonths(monthUnitsManualTarget);
        monthly_summary["revenue_target"].shopify = fillAllMonths(monthShopifyManualTarget);
        monthly_summary["revenue_target"].amazon = fillAllMonths(monthAmazonManualTarget);
        monthly_summary["revenue_target"].wholesale = fillAllMonths(monthWholesaleManualTarget);

        Object.keys(newData).forEach((month) => {
            newData[month] = {
                ...newData[month],
                allocate_ad_spend: allocateAdSpendView,
                forecast_method: selectedForecastMethod,
                ad_spend: {
                    mer: currentAdSpendMer,
                    product_ad_spend: currentProductAdSpend,
                    aov: currentAovAdSpend,
                    revenue: revenueAdSpendCalc,
                    quantity: quantityAdSpendCalc,
                    beroas: currentBeroasAdSpend,
                    contribution_margin: marginAdSpendCalc
                },
                manual_revenue: {
                    revenue_target: currentProductRevenueTarget,
                    aov: currentAovRevenue
                },
                channel_split: {
                    shopify: currentShopifyChannel,
                    amazon: currentAmazonChannel,
                    wholesale: currentWholesaleChannel
                },
            };
        });

        const newDataByForecast = {
            ...(editedForecastData || {}),
            month: {
                ...(editedForecastData?.month || {}),
                [selectedProduct]: {
                    ...(editedForecastData?.month?.[selectedProduct] || {}),
                    months: {
                        ...(editedForecastData?.month?.[selectedProduct]?.months || {}),
                        ...newData
                    },
                    monthly_summary: monthly_summary,
                    forecast_period: selectedForecastType,
                    forecast_last_period: selectedForecastType
                }
            }
        };
        setEditedForecastData(newDataByForecast);
        setMonthlySummaryByMonth(monthly_summary);

    }

    const handleAcceptAdSpendAllocationsByMonths = (allocations) => {

        const newData = getEditedData({
            forecastData,
            editedForecastData,
            selectedProduct
        });

        Object.keys(newData).forEach((month) => {
            newData[month].ad_spend_allocations = allocations;
        });

        const newDataByForecast = {
            ...(editedForecastData || {}),
            month: {
                ...(editedForecastData?.month || {}),
                [selectedProduct]: {
                    ...(editedForecastData?.month?.[selectedProduct] || {}),
                    months: {
                        ...(editedForecastData?.month?.[selectedProduct]?.months || {}),
                        ...newData
                    },
                    forecast_period: selectedForecastType,
                    forecast_last_period: selectedForecastType
                }
            }
        };

        setEditedForecastData(newDataByForecast);
    }

    const getMonthSummaryMethodsByEachMonth = () => {
        const newData = getEditedData({
            forecastData,
            editedForecastData,
            selectedProduct
        });
        const methods = {};
        Object.entries(newData).forEach(([month, values]) => {
            methods[month] = values?.forecast_method || "ad-spend"
        });
        return methods;
    }

    const handleOnCreateNewProduct = async ({
        name
    }) => {
        await dispatch(createNewGroup({
            creationData: {
                name
            }
        })).unwrap();
        await dispatch(getGroupsBySelect({}));
    }

    useEffect(() => {
        if (!selectedForecast || !forecastData) return;
        setMonthMethods(getMonthSummaryMethodsByEachMonth());
    }, [monthlySummaryByMonth, selectedForecast, forecastData]);

    useEffect(() => {
        if (!selectedForecast || !forecastData) return;
        if (showPreview) {
            const forecastData = selectedForecast?.data || null;
            
            if (forecastData) {
                const processedData = {};
                Object.keys(forecastData.month || {}).forEach((productId) => {
                    const productData = forecastData.month?.[productId];
                    const productName = (groupsBySelect || []).find((product) => product.value === Number(productId))?.label || "";
                    
                    if (productData && productData.forecast_last_period === 'month') {
                        const newTotal = {};
                        Object.entries(productData.months).forEach(([month, values]) => {
                            const forecastMethod = values?.forecast_method;
                            const summaryKey = forecastMethod === 'ad-spend' ? 'ad_spend' : 'revenue_target';
                            newTotal[month] = productData.monthly_summary?.[summaryKey]?.total_revenue[month];
                        })
                        processedData[productId] = {
                            name: productName,
                            total_revenue: newTotal
                        };
                    }
                });

                Object.keys(forecastData.year || {}).forEach((productId) => {
                    const productData = forecastData.year?.[productId];
                    const productName = (groupsBySelect || []).find((product) => product.value === Number(productId))?.label || "";

                    if (productData && productData.forecast_last_period === 'year') {
                        const forecastMethod = productData?.forecast_method;
                        const summaryKey = forecastMethod === 'ad-spend' ? 'ad_spend' : 'revenue_target';
                        processedData[productId] = {
                            name: productName,
                            total_revenue: productData.monthly_summary?.[summaryKey]?.total_revenue || {}
                        };
                    }
                });
                
                setPreviewData(processedData);
            }
        }
    }, [showPreview, forecastId, groupsBySelect, selectedForecast, forecastData]);

    useEffect(() => {
        if (!selectedForecast || !forecastData) return;
        if (selectedView === "all_products") {
            const allTotals = totals?.total_all_products;
            if (selectedChannel === "all_channels") setTotalsByProducts(allTotals?.all);
            if (selectedChannel === "shopify_channel") setTotalsByProducts(allTotals?.shopify);
            if (selectedChannel === "amazon_channel") setTotalsByProducts(allTotals?.amazon);
            if (selectedChannel === "wholesale_channel") setTotalsByProducts(allTotals?.wholesale);
        }
        if (selectedView === "selected_product") {
            const eachProduct = totals?.totals_by_each_product;
            const found = eachProduct.find(item => Object.keys(item)[0] === String(selectedProduct));
            const totalsByProduct = found ? found[selectedProduct]?.calculated_channels : null;
            if (selectedChannel === "all_channels" && totalsByProduct) setTotalsByProducts(totalsByProduct?.all);
            if (selectedChannel === "shopify_channel" && totalsByProduct) setTotalsByProducts(totalsByProduct?.shopify);
            if (selectedChannel === "amazon_channel" && totalsByProduct) setTotalsByProducts(totalsByProduct?.amazon);
            if (selectedChannel === "wholesale_channel" && totalsByProduct) setTotalsByProducts(totalsByProduct?.wholesale);
        }
    }, [selectedChannel, totals, selectedView, selectedProduct, selectedForecast, forecastData]);

    // Helper function to update month data
    const updateMonthData = () => {
        if (!selectedProduct || !selectedMonth) return;

        const existingForecastData = forecastData?.month?.[selectedProduct]?.months?.[selectedMonth];
        const existingEditedData = editedForecastData?.month?.[selectedProduct]?.months?.[selectedMonth];
        const editedMonthNotEqualPrevious = editedMonth !== selectedMonth;
        const editedProductNotEqualPrevious = editedSelectedProduct !== selectedProduct;
        const notTheSameMethod = jumpFromMethod !== "month";
        let monthlySummary = null;
        let monthData = null;
        if (existingEditedData) {
            const monthProductData = editedForecastData?.month?.[selectedProduct];
            if (monthProductData && selectedMonth) {
                const monthForecastData = monthProductData?.months?.[selectedMonth];
                let allocateSpend = monthForecastData?.allocate_ad_spend || false;
                let forecastMethod = monthForecastData?.forecast_method || "ad-spend";
                let adSpendMerVal = monthForecastData?.ad_spend?.mer || 0;
                let adSpendProductVal = monthForecastData?.ad_spend?.product_ad_spend || 0;
                let adSpendAovVal = monthForecastData?.ad_spend?.aov || 0;
                let adSpendRevenueVal = monthForecastData?.ad_spend?.revenue || 0;
                let adSpendQuantityVal = monthForecastData?.ad_spend?.quantity || 0;
                let adSpendBeroasVal = monthForecastData?.ad_spend?.beroas || 0;
                let adSpendContributionVal = monthForecastData?.ad_spend?.contribution_margin || 0;
                let adSpendRevenueTargetVal = monthForecastData?.manual_revenue?.revenue_target || 0;
                let adSpendAovRevenueVal = monthForecastData?.manual_revenue?.aov || 0;
                let adSpendShopifyVal = monthForecastData?.channel_split?.shopify || 0;
                let adSpendAmazonVal = monthForecastData?.channel_split?.amazon || 0;
                let adSpendWholesaleVal = monthForecastData?.channel_split?.wholesale || 0;
                let adSpendAllocationsVal = monthForecastData?.ad_spend_allocations || defaultAdSpendAllocations;
                let monthPercentages = adSpendShopifyVal + adSpendAmazonVal + adSpendWholesaleVal;
                let monthlySummaryVal = monthProductData?.monthly_summary || {
                    "ad_spend": defaultMonthlySummary,
                    "revenue_target": defaultMonthlySummary
                };
                if (editedMonthNotEqualPrevious || editedProductNotEqualPrevious || notTheSameMethod) {
                    setAllocateAdSpendView(allocateSpend);
                    setAdSpendMer(adSpendMerVal);
                    setSelectedForecastMethod(forecastMethod);
                    setProductAdSpend(adSpendProductVal);
                    setAovAdSpend(adSpendAovVal);
                    setRevenueAdSpend(adSpendRevenueVal);
                    setBeroasAdSpend(adSpendBeroasVal); 
                    setMarginAdSpend(adSpendContributionVal); 
                    setQuantityAdSpend(adSpendQuantityVal); 
                    setProductRevenueTarget(adSpendRevenueTargetVal); 
                    setAovRevenue(adSpendAovRevenueVal); 
                    setMonthShopifyChannel(adSpendShopifyVal);
                    setMonthAmazonChannel(adSpendAmazonVal);  
                    setMonthWholesaleChannel(adSpendWholesaleVal); 
                    setAdSpendAllocationsByMonth(adSpendAllocationsVal);
                    setPercentagesChannelsByMonts(monthPercentages);
                    monthlySummary = monthlySummaryVal;
                    monthData = {
                        allocate_ad_spend: allocateSpend,
                        forecast_method: forecastMethod,
                        ad_spend: {
                            mer: Number(adSpendMerVal),
                            product_ad_spend: Number(adSpendProductVal),
                            aov: Number(adSpendAovVal),
                            revenue: Number(adSpendRevenueVal),
                            quantity: Number(adSpendQuantityVal),
                            beroas: Number(adSpendBeroasVal),
                            contribution_margin: Number(adSpendContributionVal)
                        },
                        manual_revenue: {
                            revenue_target: Number(adSpendRevenueTargetVal),
                            aov: Number(adSpendAovRevenueVal)
                        },
                        channel_split: {
                            shopify: Number(adSpendShopifyVal),
                            amazon: Number(adSpendAmazonVal),
                            wholesale: Number(adSpendWholesaleVal)
                        },
                        ad_spend_allocations: adSpendAllocationsVal
                    };
                } else {
                    setAllocateAdSpendView(allocateAdSpendView);
                    setAdSpendMer(adSpendMer);
                    setProductAdSpend(productAdSpend);
                    setAovAdSpend(aovAdSpend);
                    setBeroasAdSpend(beroasAdSpend); 
                    setSelectedForecastMethod(selectedForecastMethod);
                    setProductRevenueTarget(productRevenueTarget); 
                    setAovRevenue(aovRevenue); 
                    setMonthShopifyChannel(monthShopifyChannel);
                    setMonthAmazonChannel(monthAmazonChannel);  
                    setMonthWholesaleChannel(monthWholesaleChannel); 
                    setPercentagesChannelsByMonts(Number(monthShopifyChannel || 0) + Number(monthAmazonChannel || 0) + Number(monthWholesaleChannel || 0));
                    const revenueAdSpendCalc = revenueAdSpendCalculation({
                        adSpendMer,
                        productAdSpend
                    });
                    const quantityAdSpendCalc = quantityAdSpendCalculation({
                        adSpendMer,
                        productAdSpend,
                        aovAdSpend
                    })
                    const marginAdSpendCalc = marginAdSpendCalculation({
                        adSpendMer,
                        productAdSpend,
                        beroasAdSpend
                    })
                    setRevenueAdSpend(revenueAdSpendCalc);
                    setQuantityAdSpend(quantityAdSpendCalc); 
                    setMarginAdSpend(marginAdSpendCalc); 
                    const monthAov = Number(aovAdSpend);
                    const monthAdSpend = Number(productAdSpend);
                    const monthMer = Number(adSpendMer);
                    const monthRevenueAdSpend = Number(adSpendMer) * Number(productAdSpend);
                    const monthRevenueManualTarget = Number(productRevenueTarget);
                    const monthUnitsAdSpend = aovAdSpend ? (Number(adSpendMer) * Number(productAdSpend)) / Number(aovAdSpend) : 0;
                    const monthUnitsManualTarget = aovRevenue ? Number(productRevenueTarget) / Number(aovRevenue) : 0;
                    const monthShopifyAdSpend = Math.round(monthRevenueAdSpend * ((Number(monthShopifyChannel) || 0) / 100));
                    const monthAmazonAdSpend = Math.round(monthRevenueAdSpend * ((Number(monthAmazonChannel) || 0) / 100));
                    const monthWholesaleAdSpend = Math.round(monthRevenueAdSpend * ((Number(monthWholesaleChannel) || 0) / 100));
                    const monthShopifyManualTarget = Math.round(monthRevenueManualTarget * ((Number(monthShopifyChannel) || 0) / 100));
                    const monthAmazonManualTarget = Math.round(monthRevenueManualTarget * ((Number(monthAmazonChannel) || 0) / 100));
                    const monthWholesaleManualTarget = Math.round(monthRevenueManualTarget * ((Number(monthWholesaleChannel) || 0) / 100));
                    const prevMonthlySummary = editedForecastData?.month?.[selectedProduct]?.monthly_summary
                        || forecastData?.month?.[selectedProduct]?.monthly_summary
                        || {
                            "ad_spend": defaultMonthlySummary,
                            "revenue_target": defaultMonthlySummary
                        };
                    const monthly_summary = {
                        ad_spend: {
                            aov: { ...(prevMonthlySummary?.ad_spend?.aov || {}) },
                            ad_spend: { ...(prevMonthlySummary?.ad_spend?.ad_spend || {}) },
                            mer: { ...(prevMonthlySummary?.ad_spend?.mer || {}) },
                            total_revenue: { ...(prevMonthlySummary?.ad_spend?.total_revenue || {}) },
                            total_units: { ...(prevMonthlySummary?.ad_spend?.total_units || {}) },
                            shopify: { ...(prevMonthlySummary?.ad_spend?.shopify || {}) },
                            amazon: { ...(prevMonthlySummary?.ad_spend?.amazon || {}) },
                            wholesale: { ...(prevMonthlySummary?.ad_spend?.wholesale || {}) },
                        },
                        revenue_target: {
                            aov: { ...(prevMonthlySummary?.revenue_target?.aov || {}) },
                            ad_spend: { ...(prevMonthlySummary?.revenue_target?.ad_spend || {}) },
                            mer: { ...(prevMonthlySummary?.revenue_target?.mer || {}) },
                            total_revenue: { ...(prevMonthlySummary?.revenue_target?.total_revenue || {}) },
                            total_units: { ...(prevMonthlySummary?.revenue_target?.total_units || {}) },
                            shopify: { ...(prevMonthlySummary?.revenue_target?.shopify || {}) },
                            amazon: { ...(prevMonthlySummary?.revenue_target?.amazon || {}) },
                            wholesale: { ...(prevMonthlySummary?.revenue_target?.wholesale || {}) },
                        }
                    };
                    monthly_summary["ad_spend"].aov[selectedMonth] = monthAov;
                    monthly_summary["ad_spend"].ad_spend[selectedMonth] = monthAdSpend;
                    monthly_summary["ad_spend"].mer[selectedMonth] = monthMer;
                    monthly_summary["ad_spend"].total_revenue[selectedMonth] = monthRevenueAdSpend;
                    monthly_summary["ad_spend"].total_units[selectedMonth] = monthUnitsAdSpend;
                    monthly_summary["ad_spend"].shopify[selectedMonth] = monthShopifyAdSpend;
                    monthly_summary["ad_spend"].amazon[selectedMonth] = monthAmazonAdSpend;
                    monthly_summary["ad_spend"].wholesale[selectedMonth] = monthWholesaleAdSpend;
                    monthly_summary["revenue_target"].aov[selectedMonth] = monthAov;
                    monthly_summary["revenue_target"].ad_spend[selectedMonth] = monthAdSpend;
                    monthly_summary["revenue_target"].mer[selectedMonth] = monthMer;
                    monthly_summary["revenue_target"].total_revenue[selectedMonth] = monthRevenueManualTarget;
                    monthly_summary["revenue_target"].total_units[selectedMonth] = monthUnitsManualTarget;
                    monthly_summary["revenue_target"].shopify[selectedMonth] = monthShopifyManualTarget;
                    monthly_summary["revenue_target"].amazon[selectedMonth] = monthAmazonManualTarget;
                    monthly_summary["revenue_target"].wholesale[selectedMonth] = monthWholesaleManualTarget;
                    setAdSpendAllocationsByMonth(adSpendAllocationsByMonth);
                    monthlySummary = monthly_summary;
                    monthData = {
                        allocate_ad_spend: allocateAdSpendView,
                        forecast_method: selectedForecastMethod,
                        ad_spend: {
                            mer: Number(adSpendMer),
                            product_ad_spend: Number(productAdSpend),
                            aov: Number(aovAdSpend),
                            revenue: Number(revenueAdSpendCalc),
                            quantity: Number(quantityAdSpendCalc),
                            beroas: Number(beroasAdSpend),
                            contribution_margin: Number(marginAdSpendCalc)
                        },
                        manual_revenue: {
                            revenue_target: Number(productRevenueTarget),
                            aov: Number(aovRevenue)
                        },
                        channel_split: {
                            shopify: Number(monthShopifyChannel),
                            amazon: Number(monthAmazonChannel),
                            wholesale: Number(monthWholesaleChannel)
                        },
                        ad_spend_allocations: adSpendAllocationsByMonth,
                    };
                }
            }
        } else if (existingForecastData) {
            const monthProductData = forecastData?.month?.[selectedProduct];
            if (monthProductData && selectedMonth) {
                const monthForecastData = monthProductData?.months?.[selectedMonth];
                setAllocateAdSpendView(monthForecastData?.allocate_ad_spend || false);
                setAdSpendMer(monthForecastData?.ad_spend?.mer || 0);
                setProductAdSpend(monthForecastData?.ad_spend?.product_ad_spend || 0);
                setAovAdSpend(monthForecastData?.ad_spend?.aov || 0);
                setRevenueAdSpend(monthForecastData?.ad_spend?.revenue || 0);
                setQuantityAdSpend(monthForecastData?.ad_spend?.quantity || 0);
                setBeroasAdSpend(monthForecastData?.ad_spend?.beroas || 0);
                setMarginAdSpend(monthForecastData?.ad_spend?.contribution_margin || 0);
                setProductRevenueTarget(monthForecastData?.manual_revenue?.revenue_target || 0);
                setAovRevenue(monthForecastData?.manual_revenue?.aov || 0);
                setMonthShopifyChannel(monthForecastData?.channel_split?.shopify || 0);
                setMonthAmazonChannel(monthForecastData?.channel_split?.amazon || 0);
                setMonthWholesaleChannel(monthForecastData?.channel_split?.wholesale || 0);
                setSelectedForecastMethod(monthForecastData?.forecast_method || "ad-spend");
                setPercentagesChannelsByMonts(Number(monthForecastData?.channel_split?.shopify || 0) + Number(monthForecastData?.channel_split?.amazon || 0) + Number(monthForecastData?.channel_split?.wholesale || 0));
                setAdSpendAllocationsByMonth(monthForecastData?.ad_spend_allocations || defaultAdSpendAllocations);
                monthData = {
                    allocate_ad_spend: monthForecastData?.allocate_ad_spend || false,
                    forecast_method: monthForecastData?.forecast_method || "ad-spend",
                    ad_spend: {
                        mer: Number(monthForecastData?.ad_spend?.mer || 0),
                        product_ad_spend: Number(monthForecastData?.ad_spend?.product_ad_spend || 0),
                        aov: Number(monthForecastData?.ad_spend?.aov || 0),
                        revenue: Number(monthForecastData?.ad_spend?.revenue || 0),
                        quantity: Number(monthForecastData?.ad_spend?.quantity || 0),
                        beroas: Number(monthForecastData?.ad_spend?.beroas || 0),
                        contribution_margin: Number(monthForecastData?.ad_spend?.contribution_margin || 0)
                    },
                    manual_revenue: {
                        revenue_target: Number(monthForecastData?.manual_revenue?.revenue_target || 0),
                        aov: Number(monthForecastData?.manual_revenue?.aov || 0)
                    },
                    channel_split: {
                        shopify: Number(monthForecastData?.channel_split?.shopify || 0),
                        amazon: Number(monthForecastData?.channel_split?.amazon || 0),
                        wholesale: Number(monthForecastData?.channel_split?.wholesale || 0)
                    },
                    ad_spend_allocations: monthForecastData?.ad_spend_allocations || defaultAdSpendAllocations
                };
                monthlySummary = monthProductData?.monthly_summary || {
                    "ad_spend": defaultMonthlySummary,
                    "revenue_target": defaultMonthlySummary
                };
            }
        } else {
            setAllocateAdSpendView(false);
            setAdSpendMer(0);
            setProductAdSpend(0);
            setAovAdSpend(0);
            setRevenueAdSpend(0);
            setQuantityAdSpend(0);
            setBeroasAdSpend(0);
            setMarginAdSpend(0);
            setProductRevenueTarget(0);
            setAovRevenue(0);
            setMonthShopifyChannel(60);
            setMonthAmazonChannel(30);
            setMonthWholesaleChannel(10);
            setPercentagesChannelsByMonts(100);
            setSelectedForecastType("month");
            setSelectedForecastMethod("ad-spend");
            setAdSpendAllocationsByMonth(defaultAdSpendAllocations);
            monthData = {
                allocate_ad_spend: false,
                forecast_period: "month",
                forecast_method: "ad-spend",
                ad_spend: {
                    mer: 0,
                    product_ad_spend: 0,
                    aov: 0,
                    revenue: 0,
                    quantity: 0,
                    beroas: 0,
                    contribution_margin: 0
                },
                manual_revenue: {
                    revenue_target: 0,
                    aov: 0
                },
                channel_split: {
                    shopify: 60,
                    amazon: 30,
                    wholesale: 10
                },
                ad_spend_allocations: defaultAdSpendAllocations
            }
            const existedSummary = forecastData?.month?.[selectedProduct]?.monthly_summary;
            const editedSummary = editedForecastData?.month?.[selectedProduct]?.monthly_summary;
            if (editedSummary) { 
                monthlySummary = editedSummary;
            } else if (existedSummary) {
                monthlySummary = existedSummary;
            } else {
                monthlySummary = {
                    "ad_spend": defaultMonthlySummary,
                    "revenue_target": defaultMonthlySummary
                };
            }
        }
        const newData = {
            ...(editedForecastData || {}),
            month: {
                ...(editedForecastData?.month || {}),
                [selectedProduct]: {
                    ...(editedForecastData?.month?.[selectedProduct] || {}),
                    months: {
                        ...(editedForecastData?.month?.[selectedProduct]?.months || {}),
                        [selectedMonth]: monthData
                    },
                    monthly_summary: monthlySummary,
                    forecast_period: selectedForecastType,
                }
            }
        };
        setJumpFromMethod("month");
        setEditedMonth(selectedMonth);
        setEditedSelectedProduct(selectedProduct);
        setEditedForecastData(newData);
        setMonthlySummaryByMonth(monthlySummary);
    };

    // Helper function to update year data
    const updateYearData = () => {
        if (!selectedProduct) return;

        const existingForecastData = forecastData?.year?.[selectedProduct];
        const existingEditedData = editedForecastData?.year?.[selectedProduct];
        const editingModeNotEqualPrevious = !editingYearMode;
        const editedProductNotEqualPrevious = editedSelectedProduct !== selectedProduct;
        const notTheSameMethod = jumpFromMethod !== "year";

        let monthlySummary = null;
        let yearData = null;
        
        if (existingEditedData) {
            let allocateSpend = existingEditedData?.allocate_ad_spend || false;
            let annualAdSpendVal = existingEditedData?.ad_spend?.annual_ad_spend || 0;
            let forecastMethod = existingEditedData?.forecast_method || "ad-spend";
            let merVal = existingEditedData?.ad_spend?.mer || 0;
            let aovVal = existingEditedData?.ad_spend?.aov || 0;
            let beroasVal = existingEditedData?.ad_spend?.beroas || 0;
            let annualRevenueVal = existingEditedData?.ad_spend?.annual_revenue || 0;
            let annualUnitsVal = existingEditedData?.ad_spend?.annual_units || 0;
            let monthlyAllocationVal = existingEditedData?.monthly_allocation || defaultAllocation;
            let shopifyVal = existingEditedData?.channel_split?.shopify || 0;
            let amazonVal = existingEditedData?.channel_split?.amazon || 0;
            let wholesaleVal = existingEditedData?.channel_split?.wholesale || 0;
            let adSpendAllocationsVal = existingEditedData?.ad_spend_allocations || defaultAdSpendAllocations;
            let exPercentagesChannelsByYear = shopifyVal + amazonVal + wholesaleVal;
            let adSpendRevenueTargetYearVal = existingEditedData?.manual_revenue?.revenue_target || 0;
            let adSpendAovRevenueYearVal = existingEditedData?.manual_revenue?.aov || 0;
            let monthlyYearVal = existingEditedData?.monthly_summary || {
                "ad_spend": defaultMonthlySummary,
                "revenue_target": defaultMonthlySummary
            };
            if (editingModeNotEqualPrevious || editedProductNotEqualPrevious || notTheSameMethod) {
                setAllocateAdSpendView(allocateSpend);
                setAnnualAdSpendYear(annualAdSpendVal);
                setMerYear(merVal);
                setAovYear(aovVal);
                setBeroasYear(beroasVal);
                setSelectedForecastMethod(forecastMethod);
                setAnnualRevenueYear(annualRevenueVal);
                setAnnualUnitsYear(annualUnitsVal);
                setMonthlyAllocationData(monthlyAllocationVal);
                setYearShopifyChannel(shopifyVal);
                setYearAmazonChannel(amazonVal);
                setYearWholesaleChannel(wholesaleVal);
                setProductRevenueTargetYear(adSpendRevenueTargetYearVal); 
                setAovRevenueYear(adSpendAovRevenueYearVal); 
                setAdSpendAllocationsByYear(adSpendAllocationsVal);
                setPercentagesChannelsByYear(exPercentagesChannelsByYear);
                monthlySummary = monthlyYearVal;
                yearData = {
                    allocate_ad_spend: allocateSpend,
                    forecast_method: forecastMethod,
                    monthly_allocation: monthlyAllocationVal,
                    ad_spend_allocations: adSpendAllocationsVal,
                    ad_spend: {
                        annual_ad_spend: Number(annualAdSpendVal),
                        mer: Number(merVal),
                        aov: Number(aovVal),
                        beroas: Number(beroasVal),
                        annual_revenue: Number(annualRevenueVal),
                        annual_units: Number(annualUnitsVal),
                    },
                    manual_revenue: {
                        revenue_target: Number(adSpendRevenueTargetYearVal),
                        aov: Number(adSpendAovRevenueYearVal)
                    },
                    channel_split: {
                        shopify: Number(shopifyVal),
                        amazon: Number(amazonVal),
                        wholesale: Number(wholesaleVal)
                    },
                };
            } else {
                const annualUnitsCalc = annualUnitsCalculation({
                    merYear,
                    aovYear,
                    annualAdSpendYear
                });
                const annualRevenueCalc = annualRevenueCalculation({
                    merYear,
                    annualAdSpendYear
                })
                setAllocateAdSpendView(allocateAdSpendView);
                setAnnualAdSpendYear(annualAdSpendYear);
                setMerYear(merYear);
                setAovYear(aovYear);
                setBeroasYear(beroasYear);
                setAnnualRevenueYear(annualRevenueCalc);
                setAnnualUnitsYear(annualUnitsCalc);
                setMonthlyAllocationData(monthlyAllocationData);
                setSelectedForecastMethod(selectedForecastMethod);
                setYearShopifyChannel(yearShopifyChannel);
                setYearAmazonChannel(yearAmazonChannel);
                setYearWholesaleChannel(yearWholesaleChannel);
                setProductRevenueTargetYear(productRevenueTargetYear); 
                setAovRevenueYear(aovRevenueYear); 
                setPercentagesChannelsByYear(Number(yearShopifyChannel || 0) + (Number(yearAmazonChannel) || 0) + (Number(yearWholesaleChannel) || 0));
                const prevYearSummary = editedForecastData?.year?.[selectedProduct]?.monthly_summary
                    || forecastData?.year?.[selectedProduct]?.monthly_summary
                    || {
                        "ad_spend": defaultMonthlySummary,
                        "revenue_target": defaultMonthlySummary
                    };
                const monthly_summary = {
                    ad_spend: {
                        aov: { ...(prevYearSummary?.ad_spend?.aov || {}) },
                        ad_spend: { ...(prevYearSummary?.ad_spend?.ad_spend || {}) },
                        mer: { ...(prevYearSummary?.ad_spend?.mer || {}) },
                        total_revenue: { ...(prevYearSummary?.ad_spend?.total_revenue || {}) },
                        total_units: { ...(prevYearSummary?.ad_spend?.total_units || {}) },
                        shopify: { ...(prevYearSummary?.ad_spend?.shopify || {}) },
                        amazon: { ...(prevYearSummary?.ad_spend?.amazon || {}) },
                        wholesale: { ...(prevYearSummary?.ad_spend?.wholesale || {}) },
                    },
                        revenue_target: {
                            aov: { ...(prevYearSummary?.revenue_target?.aov || {}) },
                            ad_spend: { ...(prevYearSummary?.revenue_target?.ad_spend || {}) },
                            mer: { ...(prevYearSummary?.revenue_target?.mer || {}) },
                            total_revenue: { ...(prevYearSummary?.revenue_target?.total_revenue || {}) },
                            total_units: { ...(prevYearSummary?.revenue_target?.total_units || {}) },
                            shopify: { ...(prevYearSummary?.revenue_target?.shopify || {}) },
                            amazon: { ...(prevYearSummary?.revenue_target?.amazon || {}) },
                            wholesale: { ...(prevYearSummary?.revenue_target?.wholesale || {}) },
                        }
                    };

                const yearAov = Number(aovYear);
                const yearAdSpend = Number(annualAdSpendYear);
                const yearMer = Number(merYear);
                const yearRevenue = Number(annualRevenueCalc);
                const yearUnits = Number(annualUnitsCalc);
                const yearShopify = Math.round(yearRevenue * ((Number(yearShopifyChannel) || 0) / 100));
                const yearAmazon = Math.round(yearRevenue * ((Number(yearAmazonChannel) || 0) / 100));
                const yearWholesale = Math.round(yearRevenue * ((Number(yearWholesaleChannel) || 0) / 100));
                const monthUnitsManualTarget = aovRevenueYear ? Number(productRevenueTargetYear) / Number(aovRevenueYear) : 0;
                const yearWholesaleAdSpend = Math.round(productRevenueTargetYear * ((Number(yearWholesaleChannel) || 0) / 100));
                const yearShopifyManualTarget = Math.round(productRevenueTargetYear * ((Number(yearShopifyChannel) || 0) / 100));
                const yearAmazonManualTarget = Math.round(productRevenueTargetYear * ((Number(yearAmazonChannel) || 0) / 100));
                setAdSpendAllocationsByYear(adSpendAllocationsByYear);
                
                monthly_summary["ad_spend"].aov = fillAllMonths(yearAov);
                monthly_summary["ad_spend"].ad_spend = fillAllMonths(yearAdSpend);
                monthly_summary["ad_spend"].mer = fillAllMonths(yearMer);
                monthly_summary["ad_spend"].total_revenue = fillAllMonths(yearRevenue);
                monthly_summary["ad_spend"].total_units = fillAllMonths(yearUnits);
                monthly_summary["ad_spend"].shopify = fillAllMonths(yearShopify);
                monthly_summary["ad_spend"].amazon = fillAllMonths(yearAmazon);
                monthly_summary["ad_spend"].wholesale = fillAllMonths(yearWholesale);
                monthly_summary["revenue_target"].aov = fillAllMonths(yearAov);
                monthly_summary["revenue_target"].ad_spend = fillAllMonths(yearAdSpend);
                monthly_summary["revenue_target"].mer = fillAllMonths(yearMer);
                monthly_summary["revenue_target"].total_revenue = fillAllMonths(productRevenueTargetYear);
                monthly_summary["revenue_target"].total_units = fillAllMonths(monthUnitsManualTarget);
                monthly_summary["revenue_target"].shopify = fillAllMonths(yearShopifyManualTarget);
                monthly_summary["revenue_target"].amazon = fillAllMonths(yearAmazonManualTarget);
                monthly_summary["revenue_target"].wholesale = fillAllMonths(yearWholesaleAdSpend);

                monthlySummary = recalculateMonthlySummaryByYear(monthly_summary, monthlyAllocationData);

                yearData = {
                    allocate_ad_spend: allocateAdSpendView,
                    forecast_method: selectedForecastMethod,
                    monthly_allocation: monthlyAllocationData,
                    ad_spend_allocations: adSpendAllocationsByYear,
                    ad_spend: {
                        annual_ad_spend: Number(annualAdSpendYear),
                        mer: Number(merYear),
                        aov: Number(aovYear),
                        beroas: Number(beroasYear),
                        annual_revenue: Number(annualRevenueCalc),
                        annual_units: Number(annualUnitsCalc),
                    },
                    manual_revenue: {
                        revenue_target: Number(productRevenueTargetYear),
                        aov: Number(aovRevenueYear)
                    },
                    channel_split: {
                        shopify: Number(yearShopifyChannel),
                        amazon: Number(yearAmazonChannel),
                        wholesale: Number(yearWholesaleChannel)
                    },
                };
            }
        } else if (existingForecastData) {
            setAllocateAdSpendView(existingForecastData?.allocate_ad_spend || false);
            setAnnualAdSpendYear(existingForecastData?.ad_spend?.annual_ad_spend || 0);
            setMerYear(existingForecastData?.ad_spend?.mer || 0);
            setAovYear(existingForecastData?.ad_spend?.aov || 0);
            setBeroasYear(existingForecastData?.ad_spend?.beroas || 0);
            setAnnualRevenueYear(existingForecastData?.ad_spend?.annual_revenue || 0);
            setAnnualUnitsYear(existingForecastData?.ad_spend?.annual_units || 0);
            setMonthlyAllocationData(existingForecastData?.monthly_allocation || defaultAllocation);
            setYearShopifyChannel(existingForecastData?.channel_split?.shopify || 0);
            setYearAmazonChannel(existingForecastData?.channel_split?.amazon || 0);
            setYearWholesaleChannel(existingForecastData?.channel_split?.wholesale || 0);
            setAdSpendAllocationsByYear(existingForecastData?.ad_spend_allocations || defaultAdSpendAllocations);
            setPercentagesChannelsByYear(Number(existingForecastData?.channel_split?.shopify || 0) + (Number(existingForecastData?.channel_split?.amazon || 0) || 0) + Number(existingForecastData?.channel_split?.wholesale || 0));
            setProductRevenueTargetYear(existingForecastData?.manual_revenue?.revenue_target || 0);
            setSelectedForecastMethod(existingForecastData?.forecast_method || "ad-spend");
            setAovRevenueYear(existingForecastData?.manual_revenue?.aov || 0);
            monthlySummary = existingForecastData?.monthly_summary || {
                "ad_spend": defaultMonthlySummary,
                "revenue_target": defaultMonthlySummary
            };
            yearData = {
                allocate_ad_spend: existingForecastData?.allocate_ad_spend || false,
                forecast_method: existingForecastData?.forecast_method || "ad-spend",
                monthly_allocation: existingForecastData?.monthly_allocation || defaultAllocation,
                ad_spend_allocations: existingForecastData?.ad_spend_allocations || defaultAdSpendAllocations,
                ad_spend: {
                    annual_ad_spend: Number(existingForecastData?.ad_spend?.annual_ad_spend || 0),
                    mer: Number(existingForecastData?.ad_spend?.mer || 0),
                    aov: Number(existingForecastData?.ad_spend?.aov || 0),
                    beroas: Number(existingForecastData?.ad_spend?.beroas || 0),
                    annual_revenue: Number(existingForecastData?.ad_spend?.annual_revenue || 0),
                    annual_units: Number(existingForecastData?.ad_spend?.annual_units || 0),
                },
                manual_revenue: {
                    revenue_target: Number(existingForecastData?.manual_revenue?.revenue_target || 0),
                    aov: Number(existingForecastData?.manual_revenue?.aov || 0)
                },
                channel_split: {
                    shopify: Number(existingForecastData?.channel_split?.shopify || 0),
                    amazon: Number(existingForecastData?.channel_split?.amazon || 0),
                    wholesale: Number(existingForecastData?.channel_split?.wholesale || 0)
                },
            };
        } else {
            setAllocateAdSpendView(false);
            setAnnualAdSpendYear(0);
            setMerYear(0);
            setAovYear(0);
            setBeroasYear(0);
            setAnnualRevenueYear(0);
            setAnnualUnitsYear(0);
            setMonthlyAllocationData(defaultAllocation);
            setYearShopifyChannel(60);
            setYearAmazonChannel(30);
            setYearWholesaleChannel(10);
            setAdSpendAllocationsByYear(defaultAdSpendAllocations);
            setPercentagesChannelsByYear(100);
            setProductRevenueTargetYear(0);
            setAovRevenueYear(0);
            setSelectedForecastMethod("ad-spend");
            setSelectedForecastType("year");
            yearData = {
                allocate_ad_spend: false,
                forecast_period: "year",
                forecast_method: "ad-spend",
                monthly_allocation: defaultAllocation,
                ad_spend_allocations: defaultAdSpendAllocations,
                ad_spend: {
                    annual_ad_spend: 0,
                    mer: 0,
                    aov: 0,
                    beroas: 0,
                    annual_revenue: 0,
                    annual_units: 0,
                },
                manual_revenue: {
                    revenue_target: 0,
                    aov: 0
                },
                channel_split: {
                    shopify: 60,
                    amazon: 30,
                    wholesale: 10
                },
            };
            const existedSummary = forecastData?.year?.[selectedProduct]?.monthly_summary;
            const editedSummary = editedForecastData?.year?.[selectedProduct]?.monthly_summary;
            if (editedSummary) { 
                monthlySummary = editedSummary;
            } else if (existedSummary) {
                monthlySummary = existedSummary;
            } else {
                monthlySummary = {
                    "ad_spend": defaultMonthlySummary,
                    "revenue_target": defaultMonthlySummary
                };
            }
        }

        const newData = {
            ...(editedForecastData || {}),
            year: {
                ...(editedForecastData?.year || {}),
                [selectedProduct]: {
                    ...yearData,
                    monthly_summary: monthlySummary,
                }
            }
        };

        setJumpFromMethod("year");
        setEditingYearMode(true);
        setEditedSelectedProduct(selectedProduct);
        setEditedForecastData(newData);
        setMonthlySummaryByYear(monthlySummary);
    };

    useEffect(() => {
        if (!forecastFirstLoadComplete || !forecastDataAccept || !selectedForecast) return;
        if (updateForecastsIsLoading() || getForecastIsLoading()) return;

        if (selectedForecastType === "month") {
            updateMonthData();
        } else {
            updateYearData();
        }
    }, [
        selectedForecastType,
        selectedProduct,
        selectedMonth,
        forecastData,
        forecastFirstLoadComplete,
        forecastDataAccept,
        // Month-level editable fields
        allocateAdSpendView,
        selectedForecastMethod,
        adSpendMer,
        productAdSpend,
        aovAdSpend,
        revenueAdSpend,
        quantityAdSpend,
        beroasAdSpend,
        marginAdSpend,
        productRevenueTarget,
        aovRevenue,
        monthShopifyChannel,
        monthAmazonChannel,
        monthWholesaleChannel,
        adSpendAllocationsByMonth,
        // Year-level editable fields
        annualAdSpendYear,
        merYear,
        aovYear,
        beroasYear,
        annualRevenueYear,
        annualUnitsYear,
        monthlyAllocationData,
        yearShopifyChannel,
        yearAmazonChannel,
        yearWholesaleChannel,
        adSpendAllocationsByYear,
        productRevenueTargetYear,
        aovRevenueYear, 
        selectedForecast
    ]);

    useEffect(() => {
        if (!selectedProduct || !selectedForecastType || !selectedForecast|| !forecastData) return;

        setSavedTypes((prev) => {
            if (prev[selectedProduct] === selectedForecastType) return prev;
            return {
                ...prev,
                [selectedProduct]: selectedForecastType,
            };
        });
    }, [selectedProduct, selectedForecastType, selectedForecast, forecastData]);

    useEffect(() => {
        if (!selectedProduct || !selectedForecast|| !forecastData) return;

        const lastPeriod =
            editedForecastData?.month?.[selectedProduct]?.forecast_last_period ??
            editedForecastData?.year?.[selectedProduct]?.forecast_last_period ??
            forecastData?.month?.[selectedProduct]?.forecast_last_period ??
            forecastData?.year?.[selectedProduct]?.forecast_last_period;

        const preferredType = savedTypes[selectedProduct] ?? lastPeriod;

        if (preferredType) {
            setSelectedForecastType(preferredType);
        }
    }, [selectedProduct, selectedForecast, forecastData]);

    if (!forecastId) return null;

    return (
        <>
            <main className="w-full h-auto px-4 sm:px-6 lg:px-8 mb-8">
                <div className="h-auto py-6 pb-0 flex flex-col">
                    <div className="flex items-center mb-8 justify-between gap-4 flex-wrap">
                        <div className="flex items-center space-x-4">
                            <div className="flex items-center space-x-2">
                                <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
                                    <ArrowTrendingUpIcon className="h-6 w-6 text-white"/>
                                </div>
                                <h1 className="text-xl font-semibold text-gray-900">DTC Forecasting Dashboard</h1>
                            </div>
                            {selectedForecast && (
                                <div 
                                    className="flex flex-row items-center gap-2 bg-blue-100 text-blue-800 border-blue-200 px-4 py-0.5 rounded-full font-bold text-sm whitespace-nowrap cursor-pointer"
                                    onClick={() => {
                                        navigate(`${ROUTES.BUDGET_X_FORECAST}`)
                                    }}
                                >
                                    <ArrowLeftIcon className="h-5 w-5" />
                                    Return
                                </div>
                            )}
                            <div className="bg-blue-100 text-blue-800 border-blue-200 px-4 py-0.5 rounded-full font-bold text-sm whitespace-nowrap">
                                {selectedForecast?.name ? selectedForecast.name : "Forecasts"}
                            </div>
                            {selectedForecast && access === "edit" && (
                                <button 
                                    className="inline-flex items-center px-3 py-1 border border-transparent cursor-pointer rounded shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                    onClick={() => {
                                        setForecastEditModalIsOpen(true);
                                    }}
                                >
                                    <PencilIcon className="h-4 w-4" />
                                </button>
                            )}
                        </div> 
                    </div>
                </div>
                {!forecastFirstLoadComplete || getForecastIsLoading() ? (
                    <LoaderSpinner width="70" height="70" border="5" colorSpinner="blue" />
                ) : selectedForecast ? (
                    <section className="flex flex-col gap-6">
                        {/* Filters */}
                        <div className="flex justify-between gap-4">
                            <div className="flex flex-row gap-4">
                                <div className="flex flex-row gap-2 items-center w-56">
                                    <span>View:</span>
                                    <SelectDropdown
                                        options={viewForecastOptions}
                                        value={selectedView}
                                        onChange={setSelectedView}
                                        selectClassname="!bg-white"
                                    />
                                </div>
                                <div className="flex flex-row gap-2 items-center w-56">
                                    <span>Forecast:</span>
                                    <SelectDropdown
                                        options={forecastOptions}
                                        value={selectedChannel}
                                        onChange={setSelectedChannel}
                                        selectClassname="!bg-white"
                                    />
                                </div>
                            </div>
                            <button 
                                className="flex flex-row gap-4 items-center px-4 py-1 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary hover:bg-gray-800"
                                onClick={() => {
                                    setShowPreview(true);
                                }}
                            >
                                <span className="text-white">Show Preview</span>
                            </button>
                        </div>
                        <ForecastTotals 
                            totals={totalsByProducts}
                        />
                        <div className="rounded-lg border bg-card text-card-foreground shadow-2xs">
                            <div className="flex flex-row gap-2 p-6 justify-between">
                                <h3 className="text-2xl font-semibold leading-none tracking-tight margin-0">Revenue Calculation</h3>
                                {access === "edit" && (
                                    <button
                                        className="flex flex-row gap-4 items-center px-4 py-1 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary hover:bg-gray-800"
                                        onClick={async () => {
                                            await handleOnSaveProduct();
                                        }}
                                    >
                                        Save Edited Products
                                    </button>
                                )}
                            </div>
                            <div className="p-6 pt-0 space-y-6">
                                <ForecastPeriodSection
                                    type={selectedForecastType}
                                    setType={(type) => setSelectedForecastType(type)}
                                />
                                {selectedForecastType === "month" && (
                                    <>
                                        <div className="grid grid-cols-2 gap-4">
                                            <div className="space-y-2">
                                                <span className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                                                    Product
                                                </span>
                                                <ForecastProductSelect
                                                    key={selectedProduct}
                                                    options={groupsBySelect}
                                                    forecastData={forecastData}
                                                    access={access}
                                                    optionsIsLoading={productsByGroupIsLoading()}
                                                    createIsLoading={createProductGroupIsLoading()}
                                                    selectedProduct={selectedProduct}
                                                    handleChange={(option) => {
                                                        setSelectedProduct(option);
                                                    }}
                                                    handleOnCreate={handleOnCreateNewProduct}
                                                />
                                            </div>
                                            <div className="space-y-2">
                                                <span className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">Month</span>
                                                <SelectDropdown
                                                    key={`${selectedProduct}_${selectedMonth}`}
                                                    options={transformOptions(monthsOptions, forecastData, selectedProduct)}
                                                    value={selectedMonth}
                                                    onChange={setSelectedMonth}
                                                    selectClassname="!bg-white"
                                                />
                                            </div>
                                        </div>
                                        <ForecastMethodSection
                                            method={selectedForecastMethod}
                                            setMethod={(method) => setSelectedForecastMethod(method)}
                                        />
                                        {selectedForecastMethod === "ad-spend" && (
                                            <div className="space-y-3">
                                                <div className="flex items-center space-x-2">
                                                    <AllocateAdSpendSwitcher 
                                                        checked={allocateAdSpendView}
                                                        access={access}
                                                        setChecked={setAllocateAdSpendView}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        {selectedForecastMethod === "ad-spend" && (
                                            <div className="space-y-4">
                                                <div className="grid grid-cols-3 gap-4">
                                                    <ForecastInput
                                                        id="mer-ad-spend"
                                                        label="MER"
                                                        access={access}
                                                        inputValue={adSpendMer}
                                                        setInputValue={setAdSpendMer}
                                                        inputClassName={"!text-left"}
                                                    />
                                                    <ForecastInput
                                                        id="product-ad-spend"
                                                        label="Product Ad Spend"
                                                        access={access}
                                                        inputValue={productAdSpend}
                                                        setInputValue={setProductAdSpend}
                                                        inputClassName={"!text-left"}
                                                    />
                                                    <ForecastInput
                                                        id="aov-ad-spend"
                                                        label="AOV"
                                                        access={access}
                                                        inputValue={aovAdSpend}
                                                        setInputValue={setAovAdSpend}
                                                        inputClassName={"!text-left"}
                                                    />
                                                </div>
                                                <div className="grid grid-cols-3 gap-4">
                                                    <ForecastInput
                                                        id="revenue-ad-spend"
                                                        label="Revenue"
                                                        access={access}
                                                        inputValue={revenueAdSpend}
                                                        calculatedValue={true}
                                                        inputClassName={"!text-left"}
                                                    />
                                                    <ForecastInput
                                                        id="quantity-ad-spend"
                                                        label="Quantity"
                                                        access={access}
                                                        inputValue={quantityAdSpend}
                                                        calculatedValue={true}
                                                        calculatedWithoutTransform={true}
                                                        inputClassName={"!text-left"}
                                                    />
                                                    <ForecastInput
                                                        id="beroas-ad-spend"
                                                        label="Product BEROAS"
                                                        access={access}
                                                        inputValue={beroasAdSpend}
                                                        setInputValue={setBeroasAdSpend}
                                                        inputClassName={"!text-left"}
                                                    />
                                                </div>
                                                <div className="grid grid-cols-3 gap-4">
                                                    <ForecastInput
                                                        id="margin-ad-spend"
                                                        label="Contribution Margin"
                                                        access={access}
                                                        inputValue={marginAdSpend}
                                                        calculatedValue={true}
                                                        inputClassName={"!text-left"}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        {selectedForecastMethod === "revenue" && (
                                            <div className="grid grid-cols-2 gap-4">
                                                <ForecastInput
                                                    id="revenueTarget"
                                                    label="Product Revenue Target"
                                                    access={access}
                                                    inputValue={productRevenueTarget}
                                                    setInputValue={setProductRevenueTarget}
                                                    inputClassName={"!text-left"}
                                                />
                                                <ForecastInput
                                                    id="aov"
                                                    label="AOV"
                                                    access={access}
                                                    inputValue={aovRevenue}
                                                    setInputValue={setAovRevenue}
                                                    inputClassName={"!text-left"}
                                                />
                                            </div>
                                        )}
                                        <div className="shrink-0 bg-gray-200 h-px w-full" />
                                        <ChannelSplit
                                            key={selectedForecastType}
                                            access={access}
                                            forecastType={selectedForecastType}
                                            shopifyValue={monthShopifyChannel}
                                            onChangeShopifyValue={setMonthShopifyChannel}
                                            amazonValue={monthAmazonChannel}
                                            onChangeAmazonValue={setMonthAmazonChannel}
                                            wholesaleValue={monthWholesaleChannel}
                                            onChangeWholesaleValue={setMonthWholesaleChannel}
                                            selectedMonth={selectedMonth}
                                            selectedChannel={selectedChannel}
                                            percentages={percentagesChannelsByMonths}
                                            handleApplyAllMonths={() => {
                                                handleChannelSplitAccept();
                                            }}
                                            onReset={() => {
                                                setMonthShopifyChannel(60);
                                                setMonthAmazonChannel(30);
                                                setMonthWholesaleChannel(10);
                                            }}
                                        />
                                    </>
                                )}
                                {selectedForecastType === "year" && (
                                    <>
                                        <div className="space-y-2">
                                            <div className="flex flex-row gap-2 items-center">
                                                <span className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">Product</span>
                                                <div className="w-72">
                                                    <ForecastProductSelect
                                                        key={selectedProduct}
                                                        options={groupsBySelect}
                                                        forecastData={forecastData}
                                                        optionsIsLoading={productsByGroupIsLoading()}
                                                        createIsLoading={createProductGroupIsLoading()}
                                                        selectedProduct={selectedProduct}
                                                        handleChange={setSelectedProduct}
                                                        handleOnCreate={handleOnCreateNewProduct}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <ForecastMethodSection
                                            method={selectedForecastMethod}
                                            setMethod={(method) => setSelectedForecastMethod(method)}
                                        />
                                        {selectedForecastMethod === "ad-spend" && (
                                            <div className="space-y-3">
                                                <div className="flex items-center space-x-2">
                                                    <AllocateAdSpendSwitcher 
                                                        checked={allocateAdSpendView}
                                                        setChecked={setAllocateAdSpendView}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        {selectedForecastMethod === "ad-spend" && (
                                            <div className="space-y-4">
                                                <div className="grid grid-cols-4 gap-4">
                                                    <ForecastInput
                                                        id="annual-revenue-ad-spend"
                                                        label="Annual Ad Spend"
                                                        access={access}
                                                        inputValue={annualAdSpendYear}
                                                        setInputValue={setAnnualAdSpendYear}
                                                        inputClassName={"!text-left"}
                                                    />
                                                    <ForecastInput
                                                        id="mer-revenue-ad-spend"
                                                        label="MER"
                                                        access={access}
                                                        inputValue={merYear}
                                                        setInputValue={setMerYear}
                                                        inputClassName={"!text-left"}
                                                    />
                                                    <ForecastInput
                                                        id="aov-revenue-ad-spend"
                                                        label="AOV"
                                                        access={access}
                                                        inputValue={aovYear}
                                                        setInputValue={setAovYear}
                                                        inputClassName={"!text-left"}
                                                    />
                                                    <ForecastInput
                                                        id="beroas-revenue-ad-spend"
                                                        label="BEROAS"
                                                        access={access}
                                                        inputValue={beroasYear}
                                                        setInputValue={setBeroasYear}
                                                        inputClassName={"!text-left"}
                                                    />
                                                </div>
                                                <div className="grid grid-cols-2 gap-4">
                                                    <ForecastInput
                                                        id="annual-revenue-ad-spend"
                                                        label="Annual Revenue"
                                                        access={access}
                                                        inputValue={annualRevenueYear}
                                                        calculatedValue={true}
                                                        inputClassName={"!text-left"}
                                                    />
                                                    <ForecastInput
                                                        id="annual-units-ad-spend"
                                                        label="Annual Units"
                                                        access={access}
                                                        inputValue={annualUnitsYear}
                                                        calculatedValue={true}
                                                        calculatedWithoutTransform={true}
                                                        inputClassName={"!text-left"}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        {selectedForecastMethod === "revenue" && (
                                            <div className="grid grid-cols-2 gap-4">
                                                <ForecastInput
                                                    id="revenueTargetYear"
                                                    label="Product Revenue Target"
                                                    access={access}
                                                    inputValue={productRevenueTargetYear}
                                                    setInputValue={setProductRevenueTargetYear}
                                                    inputClassName={"!text-left"}
                                                />
                                                <ForecastInput
                                                    id="aovYear"
                                                    label="AOV"
                                                    access={access}
                                                    inputValue={aovRevenueYear}
                                                    setInputValue={setAovRevenueYear}
                                                    inputClassName={"!text-left"}
                                                />
                                            </div>
                                        )}
                                        <div className="shrink-0 bg-gray-200 h-px w-full" />
                                        <MonthlyAllocationSection 
                                            monthsData={monthlyAllocationData}
                                            access={access}
                                            onSaveMonthsData={setMonthlyAllocationData}
                                        />
                                        <div className="shrink-0 bg-gray-200 h-px w-full" />
                                        <ChannelSplit
                                            access={access}
                                            shopifyValue={yearShopifyChannel}
                                            onChangeShopifyValue={setYearShopifyChannel}
                                            amazonValue={yearAmazonChannel}
                                            onChangeAmazonValue={setYearAmazonChannel}
                                            wholesaleValue={yearWholesaleChannel}
                                            onChangeWholesaleValue={setYearWholesaleChannel}
                                            selectedMonth={selectedMonth}
                                            selectedChannel={selectedChannel}
                                            percentages={percentagesChannelsByYear}
                                            onReset={() => { 
                                                setYearShopifyChannel(60);
                                                setYearAmazonChannel(30);
                                                setYearWholesaleChannel(10);
                                            }}
                                        />
                                    </>
                                )}
                            </div>
                        </div>    
                        {allocateAdSpendView && selectedForecastMethod === "ad-spend" && (
                            <AdSpendAllocationForecast
                                key={`${selectedForecastType}_${selectedMonth}`}
                                forecastType={selectedForecastType}
                                access={access}
                                allocationsData={selectedForecastType === "month" ? adSpendAllocationsByMonth : adSpendAllocationsByYear}
                                handleOnChangeYear={setAdSpendAllocationsByYear}
                                handleOnChangeMonth={setAdSpendAllocationsByMonth}
                                handleApplyAllMonths={(allocations) => {
                                    handleAcceptAdSpendAllocationsByMonths(allocations);
                                }}
                            />
                        )}       
                        {monthMethods && (
                            <MonthlySummaryForecast 
                                summaryDataByYear={monthlySummaryByYear}
                                summaryDataByMonth={monthlySummaryByMonth}
                                forecastMethod={selectedForecastMethod}
                                forecastType={selectedForecastType}
                                selectedChannel={selectedChannel}
                                monthMethods={monthMethods}
                            />
                        )}
                    </section>
                ) : null }
            </main>
            <ForecastEditModal
                key={`${selectedForecast?.name}_${selectedForecast?.period}_${forecastId}`}
                isOpen={access === "edit" && forecastEditModalIsOpen}
                onClose={() => {
                    setForecastEditModalIsOpen(false);
                }}
                labelItem={selectedForecast?.name}
                periodItem={selectedForecast?.period}
                onAccept={async ({ name, period }) => {
                    await dispatch(createForecastRequest({ forecastId: selectedForecast?.id, name, period }));
                    setForecastEditModalIsOpen(false);
                    dispatch(getForecastRequest({ id: forecastId }));
                }}
            />
            <RevenueForecastPreview
                data={Object.values(previewData)}
                totals={totals?.total_all_products?.all}
                period={selectedForecast?.period}
                opened={showPreview}
                onClose={() => setShowPreview(false)}
                marginFromSidebar={marginFromSidebar}
            />
        </>
    )
};

export default Forecast;